import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild} from '@angular/core'
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Backend} from "@generated-backend-types";
import Attachment = Backend.App.Http.Resources.Dashboard.Attachment;
import {CoreModule} from "../../../../core.module";
import {FileManagerComponent} from "../../file-manager/file-manager.component";
import {ATTACHMENT_TYPE} from "../../../../../enums/ATTACHMENT_TYPE";
import PrivateAttachmentAttachableTypeEnum = Backend.App.Enums.Administrations.Attachments.PrivateAttachmentAttachableTypeEnum;
import PrivateAttachmentTypeEnum = Backend.App.Enums.Administrations.Attachments.PrivateAttachmentTypeEnum;

@Component({
    selector: 'app-image-card',
    templateUrl: './image-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ImageCardComponent,
            multi: true
        }
    ],
    imports: [CoreModule, FileManagerComponent],
    standalone: true
})
export class ImageCardComponent implements ControlValueAccessor {

  @ViewChild('selectImageModalTemplate') public selectImageModalTemplate!: TemplateRef<BsModalRef>;
  @Input() public titleAppendix = '';
  @Input() public type: ATTACHMENT_TYPE = ATTACHMENT_TYPE.PUBLIC;
  @Input() public privateAttachmentAttachableType?: PrivateAttachmentAttachableTypeEnum;
  @Input() public privateAttachmentType?: PrivateAttachmentTypeEnum;
  public selectImageModal?: BsModalRef<unknown>;

  openModal(): void {
    this.selectImageModal = this.modalService.show(this.selectImageModalTemplate,
      {
        ignoreBackdropClick: false,
        keyboard: true,
        backdrop: true,
        class: 'modal-fullscreen bg-transparent p-4'
      }
    )
  }

  public imageSelected(event: Attachment[]) {

    this.formControl.patchValue(event[0])
    this.selectImageModal?.hide();
  }

  public openFile() {
    if (this.formControl.value?.url) {
      window.open(this.formControl.value?.url)
    }
  }

  public constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private readonly modalService: BsModalService,
  ) {

  }

  @Input() public formControl: FormControl<Attachment | null> = this.fb.control(null);

  onTouched = () => {
    //
  };

  public registerOnChange(fn: () => void): void {
    this.formControl.registerOnChange(fn)
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if(isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  public writeValue(value: Attachment | null): void {
    this.formControl.setValue(value);
  }
}
